export enum ConfigurationCategoryType {
    single_option = "single_option",
    multiple_options = "multiple_options",
    color = "color",
}
